import { useState, useEffect } from 'react';

const useData = <T>(query: () => Promise<T>) => {
  const [data, setData] = useState<T | null>(null);
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const getData = async () => {
      setLoading(true);
      query()
        .then(setData)
        .catch(setError)
        .finally(() => setLoading(false));
    };

    getData();
    // In general queries don't change so we don't need to add them to the dependency array.
    // Otherwise consuming components need to memoize the query function to prevent an infinite loop
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return [data, loading, error] as const;
};

export default useData;
